import React from 'react';
import { useTranslation } from 'react-i18next';
import Header from './Header';
import Hero from './Hero';
import SEO from './SEO';
import Partners from './Partners';
import Builder from './Builder';

import Services from './Services';
import Industries from './Industries';
import Values from './Values';
import Performance from './Performance';
import MentoringHighlight from './MentoringHighlight';
import BlogSection from './BlogSection';
import FAQSection from './FAQSection';
import CTA from './CTA';
import Footer from './Footer';
import N8nChatWidget from './N8nChatWidget';

const SITE_URL = 'https://csl-brands.com';

const LandingPage = () => {
  const { t } = useTranslation();
  const faqItems = t('faq.items', { returnObjects: true });

  // Homepage-specific JSON-LD: the products/services offered + an FAQ block
  // that answer engines (AEO) and generative engines (GEO) can quote directly.
  const homeStructuredData = [
    {
      '@type': 'Service',
      name: 'Digital Transformation',
      provider: { '@id': `${SITE_URL}/#organization` },
      areaServed: 'Africa',
      description: t('services.items.primecorn.description'),
    },
    {
      '@type': 'Service',
      name: 'Tech Training',
      provider: { '@id': `${SITE_URL}/#organization` },
      areaServed: 'Africa',
      description: t('services.items.bootcamps.description'),
    },
    {
      '@type': 'FAQPage',
      mainEntity: (Array.isArray(faqItems) ? faqItems : []).map((item) => ({
        '@type': 'Question',
        name: item.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: item.answer,
        },
      })),
    },
  ];

  return (
    <div className="min-h-screen bg-white font-futura">
      <SEO
        path="/"
        image="/og-image.jpg"
        keywords="CSL Brands, digital transformation Africa, ESN Cameroun, tech services Cameroon, software development Africa, IT consulting Douala, business automation, KURSA, PrimeCorn, e-learning Cameroun"
        structuredData={homeStructuredData}
      />
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[60] focus:px-4 focus:py-2 focus:bg-white focus:text-csl-green focus:font-semibold focus:rounded-lg focus:shadow-lg"
      >
        {t('header.skipToContent')}
      </a>
      <Header />
      <main id="main-content">
        <Hero />
        <Partners />

        <Services />
        <Builder />
        <Industries />
        <Values />
        <Performance />
        <MentoringHighlight />
        <BlogSection />
        <FAQSection />
        <CTA />
      </main>
      <Footer />
      {/* <N8nChatWidget /> */}
    </div>
  );
};

export default LandingPage;
